import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './IrelandCraftBeersCaseStudy.css';
import goIcon from '../../img/featured-imgs/go-icon.svg';

class IrelandCraftBeersCaseStudy extends Component {
  render() {
    return (
      <div className="icb-storybook">
        <Grid>
          <Fade>
            <Row>
              <Col md={12}>
                <h1 className="page-title">Ireland Craft Beers</h1>
                <h3 className="page-description">
                  From Barley to Bottle – The World’s First Blockchain Beer
                </h3>
              </Col>
            </Row>
          </Fade>
          <Fade delay={300}>
            <Row className="content-row">
              <Col md={3} xs={12}>
                <h3 id="heading">BACKGROUND</h3>
              </Col>
              <Col md={9} xs={12} >
                <p>
                  Ireland Craft Beers (ICB) was established in 2014 to be the next step in the
                  revolution of the Irish Beer scene and help accelerate their craft beers into global
                  export markets. To become part of the ICB portfolio, producers must showcase a
                  unique and brilliant style of brewing, alongside a great Irish heritage in their
                  techniques. Being able to demonstrate uniqueness and authenticity is what sets
                  Ireland Craft Beers apart.
                </p>
                <p>
                  The team at ICB had a vision, to be able to reveal everything that a consumer would
                  want to know about the beer they were drinking, its ingredients and its brewing
                  methods.
                </p>
              </Col>
            </Row>
          </Fade>
        </Grid>
        <Fade delay={300}>
          <Grid fluid>
            <Row className="quote-row">
              <Col md={10} xs={12} mdOffset={1}>
                <h2 className="quote">
                  “More than ever, consumers want to know where their food
                  and drink comes from. Consumers want transparency, they
                  want authenticity and they want to trust in the brands they
                  purchase.”
                </h2>
                <h4> Liam Brogan, Co-Founder and Director</h4>
              </Col>
            </Row>
          </Grid>
        </Fade>
        <Grid fluid>
          <Row className="solution-image-row">
            <Fade delay={200}>
              <Col md={6}>
                <div className="featured-image landing" />
              </Col>
            </Fade>
            <Fade delay={500}>
              <Col md={6}>
                <div className="featured-image story" />
              </Col>
            </Fade>
          </Row>
        </Grid>
        <Fade>
          <Grid>
            <Row className="content-row">
              <Col md={3} xs={12}>
                <h3 id="heading">SOLUTION</h3>
              </Col>
              <Col md={9} xs={12}>
                <p>
                  To help achieve their vision ICB turned to arc-net, experts in
                  blockchain technology and supply chain traceability. ICB and arc-
                  net collaborated to create a world first, a new brand of beer that
                  would be placed on a blockchain and enable consumers to fully
                trace the {'beer\'s'} ingredients from source.
                </p>
                <p>
                  Downstream IPL is a radical mix of artisanal brewing methods and
                  the powerful spirit of digital technology. The partnership between
                  ICB and arc-net ensures every aspect of this superb quality craft
                  beer has been carefully recorded and written to the blockchain as a
                  guarantee of transparency and authenticity.
                </p>
                <p>
                  Arc-net has uniquely marked and authenticated each
                  bottle of Downstream IPL, allowing full traceability of
                  every bottle through the brewery and the supplier
                  network to the consumer.
                </p>
              </Col>
            </Row>
          </Grid>
        </Fade>
        <Fade>
          <Grid fluid>
            <Row className="quote-row">
              <Col md={10} xs={12} mdOffset={1}>
                <h2 className="quote">
                  ”Distilled ID provides Ireland Craft Beers with the tools,
                  not only to track their brewing operation but to share
                  their unique craft with their customers. The new era of
                  transparency on the blockchain helps to ensure the
                  people, the processes, and the ingredients behind craft
                  brewing are made available. In a crowded market,
                  products using Distilled ID now have a voice.”
                </h2>
                <h4> Drew Lyall, General Manager of arc-net</h4>
              </Col>
            </Row>
          </Grid>
        </Fade>
        <Fade>
          <Grid>
            <Row className="content-row">
              <Col md={3} xs={12}>
                <h3>OUTCOME</h3>
              </Col>
              <Col md={9} xs={12}>
                <p>
                  Following the successful collaboration between Ireland Craft Beers and arc-net,
                  Downstream IPL is already being stocked by a multi-national retailer in more than
                  400 stores across the UK and has secured a listing on the popular Honest Brew
                  online store.
                </p>
              </Col>
            </Row>
          </Grid>
        </Fade>
        <Grid fluid>
          <Fade>
            <Row className="quote-row">
              <Col md={10} xs={12} mdOffset={1}>
                <h2 className="quote">
                  “arc-net’s blockchain solution has enabled ICB to demonstrate that Downstream IPL
                  has been produced to the highest standards with premium raw materials. Being able
                  to share this information with our customers proves ICB’s commitment to
                  transparency and authenticity. The arc-net platform helps ICB achieve our goal of
                  revolutionising Irish brewing and distilling and in making ICB the distributor of
                  Irish Beers, Whiskey’s and Gins that retailers and consumers can trust.”
                </h2>
                <h4> Liam Brogan, Co-Founder and Director</h4>
              </Col>
            </Row>
          </Fade>
          <Fade>
            <Row>
              <a className="case-study-download"
                target="_blank"
                rel="noopener noreferrer"
                href="https://s3-eu-west-1.amazonaws.com/distilled-id/static/media/Distilled-ID-ICB-Case-Study.pdf">
                <div className="download-pdf-container">
                  <h3>View this case study as a PDF</h3>
                </div>
              </a>
            </Row>
          </Fade>
          <Fade>
            <Row className="social-row">
              <Col md={10} xs={12} mdOffset={1}>
                <h5>
                  SHARE
                </h5>
                <div className="social-links">
                  <a href="https://twitter.com/share?hashtags=%23distilledID" className="link">Twitter</a>
                  <a href="http://www.linkedin.com/shareArticle?title=%23distilledID" className="link">LinkedIn</a>
                  <a href="https://www.facebook.com/sharer.php?s=100" className="link">Facebook</a>
                </div>
              </Col>
            </Row>
          </Fade>
          <Row className="post-navigation">
            <Col Row className="buttons-container">
              <Col md={6} sm={6} xs={6}>
                <Link to="/case_studies/ailsabay" className="case-study-link">
                  <div className="navigation-control navigation-previous">
                    <div className="nav-content" id="left">
                      <div className="arrow-left">
                        <img src={goIcon} alt="previous" className="arrow-img" id="arrow-left" />
                      </div>
                      <div>
                        <span>Previous</span>
                        <h3>William Grant and Sons - Ailsa Bay</h3>
                      </div>
                    </div>
                  </div>
                </Link>
              </Col>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default IrelandCraftBeersCaseStudy;



// WEBPACK FOOTER //
// ./src/components/common/IrelandCraftBeersCaseStudy.js